module.exports = __webpack_public_path__ + "static/media/pro-noti-center-bg.398fa1a1.png";